import { defineMessages } from 'react-intl'

export default defineMessages({
  searching: {
    id: 'Searching',
    defaultMessage: 'Searching...'
  },
  noResults: {
    id: 'NoResults',
    defaultMessage: 'No Results'
  }
})
